module.exports = __webpack_public_path__ + "img/report-3.cef48f9c.jpg";